import { themeVars } from '@synoptic/ui-kit/theme/vars.js';
import { space } from '@synoptic/ui-kit/tokens.js';
import { typography } from '@synoptic/ui-kit/typography.js';
import { style } from '@vanilla-extract/css';

export const pendingCryptoPaymentModalContent = style([
  typography['bodyLg'],
  {
    display: 'flex',
    flexDirection: 'column',
    gap: space.s48,
    color: themeVars.container.foreground.secondary,
  },
]);

export const pendingCryptoPaymentModalActionRow = style([
  {
    display: 'flex',
    gap: '12px',
    alignSelf: 'end',
  },
]);

export const pendingCryptoPaymentModalIcon = style({
  margin: '0 auto',
});
